import React from "react";
import AppProvider from "./src/AppProvider";
import { GatsbyBrowser } from "gatsby";

export default (({ element }) => {
  return <AppProvider>{element}</AppProvider>;
}) as GatsbyBrowser["wrapRootElement"];
